// extracted by mini-css-extract-plugin
export var fullWidthButton = "_po-0";